<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>

    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <v-card light style="max-height: 575px">
            <v-card-text>
              <v-layout row="" wrap="">
                <v-flex xs12 sm12 md12>
                  <v-layout row wrap>
                    <v-flex xs12 sm12 md6>
                        <Muhasebekodu
                            v-model="accoutingCode.Code"
                            :tip="'new'"
                            :aktifmi="isUpdate"
                            @addAccoutingCode="addAccoutingCode(2)"
                            @updateAccoutingCode="updateAccoutingCode()"
                          ></Muhasebekodu>
                    </v-flex>
                    <v-flex xs12 sm12 md6>
                      <v-text-field
                        :label="$t('Accounting-Name')"
                        v-model="accoutingCode.CodeName"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-layout row wrap>
                    <v-flex xs12 sm12 md4>
                      <v-text-field
                        :label="$t('Alternative-Accounting-Code')"
                        v-model="accoutingCode.AlternativeCode"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md4>
                      <v-text-field
                        :label="$t('Alternative-Accounting-Name')"
                        v-model="accoutingCode.AlternativeCodeName"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md4>
                      <v-select
                        :label="$t('Account-Group-v2')"
                        v-model="accoutingCode.AccountGroup"
                        item-text="Adi"
                        item-value="Kod"
                        :items="hesapitems"
                        mask="AA"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>

          <v-card class="mt-3" light style="max-height: 575px">
            <v-card-text>
              <v-layout row="" wrap="">
                <v-flex xs12 sm12 md4>
                  <v-layout row wrap>
                    <v-flex xs12 sm12 md12>
                      <caricomp
                        v-bind:zorunlumu="false"
                        v-model="accoutingCode.AccountCodeInfo.Kod"
                      ></caricomp>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm12 md8>
                  <v-layout row wrap>
                    <v-flex xs12 sm12 md4>
                      <v-select
                        :label="$t('Currency')"
                        :items="doviztipi"
                        item-text="Title"
                        item-value="DovizKod"
                        clearable
                        v-model="accoutingCode.Currency"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 md4>
                      <v-select
                        :label="$t('Balance')"
                        :items="balanceTypeList"
                        item-text="text"
                        item-value="value"
                        v-model="accoutingCode.BalanceType"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 md4>
                      <v-switch
                        :label="$t('Reference-Required')"
                        v-model="accoutingCode.ReferanceForced"
                      ></v-switch>
                    </v-flex>
                    <v-flex xs12 sm12 md4>
                      <v-switch
                        :label="$t('Currency-Account')"
                        v-model="accoutingCode.ForeignCurrencyCode"
                      ></v-switch>
                    </v-flex>

                    <v-flex xs12 sm12 md4>
                      <v-switch
                        :label="$t('Passify-the-Account')"
                        @change="activePassive(accoutingCode.CodeActivePassive)"
                        v-model="accoutingCode.CodeActivePassive"
                      ></v-switch>
                    </v-flex>
                    <v-flex xs12 sm12 md4>
                      <v-switch
                        @change="lockedAccount(accoutingCode.CodeLocked)"
                        :label="$t('Lock-Account')"
                        v-model="accoutingCode.CodeLocked"
                      ></v-switch>
                    </v-flex>
                    <v-flex xs12 sm12 md4>
                      <v-switch
                        :label="$t('Expense-Center-Obligatory')"
                        v-model="accoutingCode.CostCenterForced"
                      ></v-switch>
                    </v-flex>

                    <v-flex
                      xs12
                      sm12
                      md4
                      v-if="accoutingCode.CodeActivePassive"
                    >
                      <tarihim
                        :v-bind="accoutingCode.ActivePassiveDate"
                        v-model="accoutingCode.ActivePassiveDate"
                        :etiket="$t('Active-Passive-Date')"
                        :aktifmi="true"
                      >
                      </tarihim>
                    </v-flex>
                    <v-flex
                      xs12
                      sm12
                      md4
                      v-if="!accoutingCode.CodeActivePassive"
                    >
                    </v-flex>
                    <v-flex xs12 sm12 md4 v-if="accoutingCode.CodeLocked">
                      <v-flex xs12 sm12 md12>
                        <tarihim
                          :v-bind="accoutingCode.LockedDate"
                          v-model="accoutingCode.LockedDate"
                          :etiket="$t('Lockdown-Date')"
                          :aktifmi="true"
                        >
                        </tarihim>
                      </v-flex>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import helpers from "@/components/app/customcomp/helpers.js";
import auth from "@/api/auth";
import tarihim from "@/components/app/customcomp/tarihim.vue";
import catimuhasebekodu from "../comp/catimuhasebekodu.vue";
import caricomp from "@/components/app/customcomp/caricomp.vue";
import Muhasebekodu from "../comp/muhasebekodu.vue";

export default {
  data() {
    return {
      LogRequest: false,
      LogRequestData: null,
      headersLog: [
        {
          text: this.$t('User'),
        },
        {
          text: this.$t('Process'),
        },
        {
          text: this.$t('Transaction-Date'),
        },
        {
          text: this.$t('Transaction-details'),
        },
      ],
      accoutingCode: {
        UserID: 0,
        CodeID: 0,
        CompanyID: 0,
        MainCodeInfo: {
          CodeID: 0,
          CompanyID: 0,
          Code: null,
          CodeName: null,
        },
        Code: null,
        CodeName: null,
        AccountGroup: null,
        AccountCodeInfo: {
          SirketKodu: 0,
          Kod: null,
          Unvan: null,
          Unvani2: null,
          MuhasebeKodu: null,
          VergiDaire: null,
          VergiNo: null,
          TCNo: null,
        },
        ForeignCurrencyCode: false,
        Currency: null,
        BalanceType: 0, //0 : tüm 1: alacak 2:borç
        CodeActivePassive: false,
        ActivePassiveDate: null,
        ActivePassiveUserID: 0,
        CodeLocked: false,
        LockedDate: null,
        LockedUserID: 0,
        AlternativeCode: null,
        AlternativeCodeName: null,
        ReferanceForced: false,
        CostCenterForced: false,
        RootCode: false,
        SectionCodeForced: false,
        SavedDate: null,
        SavedUserID: 0,
        Deleted: false,
        DeletedDate: null,
        DeletedUserId: null,
        LogList: [],
      },
      balanceTypeList: [
        {
          text: "Tüm",
          value: 0,
        },
        {
          text: this.$t("Credit"),
          value: 1,
        },
        {
          text: this.$t("Debit"),
          value: 2,
        },
      ],
      hesapitems: [],
      doviztipi: [],
      modelActive: null,
      text1: null,
      snackbar: false,
      yetkidialog: false,
      loadingvmodel: false,
      isUpdate: false,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      credentials: JSON.parse(window.localStorage.getItem("credentials")),
      loadData: {
        UserID: 0,
        CodeID: 0,
        CompanyID: 0,
        Code: null,
        SearchText: null,
      },
    };
  },
  methods: {
       updateAccoutingCode() {
      this.addAccoutingCode();
    },
    RootChange(val) {
      if (val == true) {
        var MainCodeInfo = {
          CodeID: 0,
          CompanyID: 0,
          Code: null,
          CodeName: null,
        };
        this.accoutingCode.MainCodeInfo = MainCodeInfo;
      }
    },
    getHesapKodu() {
      var params = {
        CompanyCode: this.credentials.MuhasebeSirketNo,
      };
      this.$http
        .post(auth.API_URL + "api/Definitions/CurrentGroupList", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.hesapitems = response.body;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable";
              this.snackbar = true;
            }
          }
        );
    },
    activePassive(val) {
      this.accoutingCode.CodeActivePassive = val;
      this.accoutingCode.ActivePassiveUserID = this.credentials.UserID;
      if (this.$route.query.islem == "get") {
        this.addAccoutingCode(1);
      }
    },
    lockedAccount(val) {
      this.accoutingCode.CodeLocked = val;
      this.accoutingCode.LockedUserID = this.credentials.UserID;
      if (this.$route.query.islem == "get") {
        this.addAccoutingCode(1);
      }
    },
    sendListPage() {
      var url = "#/muhasebe/muhasebekodlari/index";
      window.open(url, "_self");
    },
    openProcces(dialogText) {
      this.LogRequest = true;
      this.LogRequestData = dialogText;
    },
    getAccountData(val) {
 
      this.loadingvmodel = true;
      this.loadData.UserID = this.credentials.UserID;
      this.loadData.CompanyID = this.credentials.MuhasebeSirketNo;
      this.loadData.CodeID = val.SaveID;
      this.loadData.Code = this.accoutingCode.Code;
      this.$http
        .post(
          auth.API_URL + "api/AccountingCodes/AccountingCodeLoad",
          this.loadData,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            this.accoutingCode = response.body;
            this.$emit("closeAddDialog", response.body);
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-AccountingCodeLoad";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-AccountingCodeLoad";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    addAccoutingCode() {
      this.loadingvmodel = true;
      this.accoutingCode.UserID = this.credentials.UserID;
      this.accoutingCode.CompanyID = this.credentials.MuhasebeSirketNo;
      this.accoutingCode.SavedUserID = this.credentials.UserID;
      this.$http
        .post(
          auth.API_URL + "api/AccountingCodes/AccountingCodeSave",
          this.accoutingCode,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            if (response.body.Status) {
               this.text1 = this.$t(response.body.ResponseMessage);
              this.snackbar = true;
              this.loadingvmodel = false;
                this.getAccountData(response.body);
             
            } else {
               this.text1 = this.$t(response.body.ResponseMessage);
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-AccountingCodeSave";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-AccountingCodeSave";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    gitUpdate(Code) {
      var url =
        "#/muhasebe/muhasebekodlari/islem/id?" +
        "islem=get&Code=" +
        this.accoutingCode.Code +
        "&CompanyID=" +
        this.credentials.MuhasebeSirketNo +
        "&CodeID=" +
        Code;
      window.open(url, "_self");
      window.reload();
    },
    getCurrency() {
      var params = {
        CompanyCode: this.credentials.SirketKodu,
      };

      this.$http
        .post(auth.API_URL + "api/currency/List", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.doviztipi = response.body;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-Döviz";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-Döviz";
              this.snackbar = true;
            }
          }
        );
    },
  },
  components: {
    yetkidialog,
    snackbarcomp,
    loadingcomp,
    caricomp,
    tarihim,
    catimuhasebekodu,
    Muhasebekodu,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    this.getCurrency();
    this.getHesapKodu();
  },
  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },

    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    },
    timeformat: function (t) {
      return helpers.getTime(t);
    },
  },
};
</script>

<style>
</style>
